<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'configuracion'}">{{$t("configuracion")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'formas-de-pago', params:{idBusiness: idBusiness}}">
                                {{$t("formasDePago")}}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{action}} {{$t("formaDePago")}}</li>
                    </ol>
                </nav>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-12">
                            <h2 class="tituloNumier"><i class="fa fa-building"></i> {{nombreNegocio}}
                            </h2>
                            <hr>
                        </div>
                        <div class="col-md-8">
                            <div class="form-group">
                                <label for="nameModificador"><strong>{{$t("nombreFormaPago")}}
                                    <span style="color: red">*</span></strong></label>
                                <input type="text" class="form-control"
                                       :class="{'is-valid': formaPago.name.length >0 && formaPago.name.length <= maxNameFormaPago,
                                       'is-invalid': formaPago.name.length > maxNameFormaPago}"
                                       id="nameModificador" v-bind:placeholder="$t('introduzcaNombre')"
                                       v-model="formaPago.name" ref="name">
                                <input type="hidden" v-model="formaPago.xname">
                                <small class="form-text text-muted">{{formaPago.name.length}}/50</small>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label><strong>{{$t("tipo")}}</strong></label>
                                <el-select class="select-default"
                                           size="large"
                                           v-model="formaPago.tipo"
                                           filterable
                                           :placeholder="$t('seleccionaTipo')">
                                    <el-option v-for="tipos in listTipos"
                                               class="select-primary"
                                               :value="tipos.value"
                                               :label="tipos.label"
                                               :key="tipos.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="col-md-5" v-if="tieneSage">
                            <div class="form-group">
                                <label><strong>{{tieneDimoni ? $t('enlaceContable') : $t('sage200')}}</strong></label>
                                <el-select class="select-default select-account"
                                    v-model="formaPago.idCuenta" filterable :placeholder="$t('seleccioneUnaCuenta')">
                                        <el-option v-for="cuenta in listCuentasCobro"
                                            class="select-primary select-account"
                                            :value="cuenta.id"
                                            :label="cuenta.codigoCuenta+cuenta.codigoSubCuenta+' - '+cuenta.nombreCuenta"
                                            :key="cuenta.id">
                                            </el-option>
                                    </el-select>
                            </div>
                        </div>
                        <div class="col-md-12" v-if="tieneSage && !tieneDimoni">
                            <div class="form-group">
                                <div class="form-group">
                                    <label>
                                        <strong>{{$t("excluirDeSage")}}</strong>
                                    </label>
                                    <el-switch v-model="formaPago.excluirExportacionSage"
                                               active-color="#13ce66"
                                               inactive-color="#bcbcbc">
                                    </el-switch>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <div class="form-group">
                                    <label>
                                        <strong>{{$t("baja")}}</strong>
                                    </label>
                                    <el-switch v-model="formaPago.baja"
                                               active-color="#13ce66"
                                               inactive-color="#bcbcbc">
                                    </el-switch>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <button class="btn btn-primary" @click="saveFormaPago()" :disabled="inProgress"><i
                                    class="fa fa-check-square"></i> {{$t("guardar")}}
                            </button>
                            <router-link :to="{name:'formas-de-pago', params:{idBusiness: idBusiness, 'pag' : pag}}">
                                <button class="btn btn-danger"><i class="fa fa-window-close"></i> {{$t("cancelar")}}
                                </button>
                            </router-link>
                            <el-checkbox v-model="checkReply" border class="checkbox-element">
                                {{$t("replicar")}}
                            </el-checkbox>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <modal name="modalReply" :adaptive=true :scrollable=true height="auto"  :clickToClose=false>
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{$t("replicarFormaDePago")}}</h4>
                </div>
                <div class="modal-body">
                    <input type="checkbox" id="checkSelectAll" name="checkSelectAll" v-model="checkSelectAll"
                           @click="selectAll">
                    <label for="checkSelectAll" class="checkSelectAll">{{$t("seleccionarTodos")}}</label>

                    <div v-for="business in listBusinesses">
                        <el-checkbox v-if="business.id != idBusiness" v-model="business.checked" border
                                     class="checkbox-element" style="width: 100%">
                            {{business.establishmentName}}
                        </el-checkbox>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-default" @click="closeModal()"><i
                            class="fa fa-times-circle"></i> {{$t("cancelar")}}
                    </button>
                    <button class="btn btn-primary" @click="replyFormaPago"><i class="fa fa-check-circle"></i>
                        {{$t("aceptar")}}
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
    import swal from 'sweetalert2'
    import {Loading} from 'element-ui';
    import {
        Checkbox,
        Switch,
        DatePicker,
        Select,
        Option,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Button
    } from 'element-ui'

    export default {
        props: ['idBusiness', 'idFormaPago', 'pag'],
        created() {
            this.action = this.idFormaPago ? this.$i18n.t("editar") : this.$i18n.t("nueva");

            this.loadingGeneral = Loading.service({text: this.$t('cargando')});
            this.getIdTpvByBusiness();
            this.identificacionNegocio();
            this.getConfigDimoni();

            if (this.idFormaPago) {
                this.getFormaPago()
            }else{
                this.loadingGeneral.close();
            }
        },
        components: {
            [Checkbox.name]: Checkbox,
            [Switch.name]: Switch,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        mounted() {
            this.$refs.name.focus();
        },
        data() {
            return {
                loadingGeneral: null,

                formaPago: {
                    name: "",
                    tipo: "T",
                    baja: false,
                    xname: "",
                    idCuenta: "0",
                    excluirExportacionSage: false
                },
                checkSelectAll: false,
                listBusinesses: [],
                checkReply: false,
                maxNameFormaPago: 50,
                action: "",
                inProgress: false,
                nombreNegocio: "",
                idTpv: "",
                tieneSage: false,
                listCuentasCobro: [],
                listTipos: [{label: this.$t('tarjeta'), value: "T"}, {label: this.$t('cheque'), value: "C"}],

                tieneDimoni: false,
            }
        },
        methods: {
            getConfigDimoni() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.axios
                    .get(
                        this.$store.getters.apiUrl + "clients/tieneDimoni",
                        config
                    ).then(function(response) {
                        if (response.data.result) {
                            vm.tieneDimoni=true;       
                        } else {
                            vm.tieneDimoni=false;   
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            },
            identificacionNegocio() {

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                        idBusiness: this.idBusiness
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'general/identifyBusiness', config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.nombreNegocio = response.data.result

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },
            checkCampos() {
                if (this.formaPago.name.length > this.maxNameFormaPago) {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('laLongitudDelNombreNoPuedeSerMayorDe') + this.maxNameFormaPago + '.',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                } else if (this.formaPago.name === null || this.formaPago.name.length === 0) {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                } else {
                    return true;
                }
            },
            getFormaPago() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        idFormaPago: this.idFormaPago,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'formaspago/getFormaPagoById', config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.formaPago = response.data.result;
                            vm.formaPago.xname = response.data.result.name;

                            vm.loadingGeneral.close();
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },
            saveFormaPago() {
                if (this.checkCampos()) {
                    this.inProgress = true;

                    var config = {
                        params:{
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };
                    var params = {
                        idBusiness: this.idBusiness,
                        formaPago: this.formaPago,
                        jwt: this.$store.getters.jwt
                    };

                    let vm = this;
                    let controller = this.idFormaPago ? "editFormasPagoByBusiness" : "newFormasPagoByBusiness";
                    this.axios.post(this.$store.getters.apiUrl + 'formaspago/' + controller, params, config)
                        .then(function (response) {
                            vm.inProgress = false;

                            if (response.data.response) {
                                let notify = vm.idFormaPago ? vm.$t('actualizada') : vm.$t('creada');
                                vm.$notify({
                                    message: vm.$t('formaDePago')+ ' ' + notify + ' '+ vm.$t('correctamente'),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });

                                if (vm.checkReply) {

                                    if (!vm.idFormaPago) {
                                        vm.formaPago.xname = vm.formaPago.name;
                                    }

                                    vm.axios.get(vm.$store.getters.apiUrl + 'general/getBusinessesByUserReplicado', config)
                                        .then(function (response) {
                                            if (response.data.response) {
                                                vm.listBusinesses = response.data.result;
                                                vm.$modal.show('modalReply');
                                            } else {
                                                swal({
                                                    title: vm.$t('atencion'),
                                                    text: response.data.message,
                                                    confirmButtonClass: 'btn btn-info btn-fill',
                                                    type: 'error'
                                                });
                                            }

                                        });

                                } else {

                                    vm.$router.push({
                                        name: 'formas-de-pago',
                                        params: {idBusiness: vm.idBusiness, 'pag': vm.pag}
                                    })

                                }

                            } else {
                                swal({
                                    title: this.$t('atencion'),
                                    text: response.data.result,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
                }
            },
            replyFormaPago() {
                var config = {
                    params:{
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;

                let xbusinesses = new Array();
                this.listBusinesses.forEach(function (business) {
                    if (business.checked && business.id!==vm.idBusiness) {
                        xbusinesses.push(business);
                    }
                });

                var params = {
                    listBusinesses: xbusinesses,
                    formaPago: this.formaPago,
                    jwt: this.$store.getters.jwt
                };


                this.axios.post(this.$store.getters.apiUrl + 'formaspago/replyFormaPago', params, config)
                    .then(function (response) {
                        vm.inProgress = false;

                        if (response.data.response) {
                            vm.closeModal();
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });
            },
            //Consigo el idTpv que me hace falta para cargar las cuentas
            getIdTpvByBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                        idBusiness: this.idBusiness
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                }; 

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getTpvIdByBusiness", config)
                    .then(function (response) {

                        vm.idTpv = response.data;
                        vm.cargarCuentasPorIdTpv();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            //Cargo sólo las cuentas de tipo "Cobro" o "C"
            cargarCuentasPorIdTpv() {
                var config = {
                    params: {
                        idTpv: this.idTpv,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "importacion/getPaymentMethodsBusinessDataByIdTpv", config)
                    .then(function (response) {
                        
                        if (response.data.response) {
                            if (response.data.result.length >= 1) {
                                vm.tieneSage = true;
                            }

                            vm.listCuentasCobro.push({id:"0", codigoCuenta: "0", codigoSubCuenta: "", nombreCuenta: vm.$t('sinCuentaAsociada')});
                            response.data.result.forEach(cuenta => {
                                vm.listCuentasCobro.push(cuenta);
                            })
                            //vm.listCuentasSage = response.data.result;
                            
                            vm.respuesta = true;

                        }
                        vm.loading = false;


                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            closeModal() {
                this.$modal.hide('modalReply');
                this.$router.push({name: 'formas-de-pago', params: {idBusiness: this.idBusiness, 'pag': this.pag}})
            },
            selectAll() {
                if (this.checkSelectAll) {
                    this.listBusinesses.forEach(function (business) {
                        business.checked = false;
                    });
                } else {
                    this.listBusinesses.forEach(function (business) {
                        business.checked = true;
                    });
                }
            }
        }

    }
</script>

<style scoped>
    .card {
        padding: 20px;
    }
</style>




// WEBPACK FOOTER //
// src/pages/Widgets/FormasPago/FormasPagoForm.vue